export default {
  recentClasses: [],
  recentClassesCount: [],
}
